export const publicRoutes = [
  '/benefits',
  '/help-centre/legal/terms-and-conditions/',
  '/help-centre/student',
  '/help-centre/author',
  '/help-centre/referral-partner',
  '/help-centre/legal',
]
